import React, { useState, useRef } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function UploadButton({ onUploaded, accept, label = "Upload File", variant = "outline", multiple = false, testid = "upload-button" }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef();

  const handleChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const results = [];
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        results.push(data);
      }
      results.forEach((r) => onUploaded && onUploaded(r));
      toast.success(`${results.length} file${results.length === 1 ? "" : "s"} uploaded`);
    } catch (err) {
      toast.error("Upload failed. Please try again.");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept={accept} multiple={multiple} className="hidden" onChange={handleChange} data-testid={`${testid}-input`} />
      <Button type="button" variant={variant} disabled={busy} onClick={() => ref.current?.click()} data-testid={testid}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        {label}
      </Button>
    </>
  );
}
